/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// Data Hook Generator
// import useDataHook from "src/api-helpers";
import useDataHook from "@console/cloud-pal-community/api-helpers";

// Config file
import config from "./usePartialToolConfig";

// By default we export the data hook
export default useDataHook(config);